import { createTRPCProxyClient, httpBatchLink } from '@trpc/client';
import type { AppRouter } from '@hone-study/backend/src/router';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export const trpc = createTRPCProxyClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${API_URL}/trpc`,
      // Include credentials for BetterAuth session cookies
      fetch: (url, options) => fetch(url, { ...options, credentials: 'include' }),
    }),
  ],
});
